// openEHR AM model — BMM package org.openehr.am.aom2.persistence.primitive
// Generated by tasks/split_model_by_bmm_packages.ts from tasks/bmm_package_map.json.
// Package boundaries follow the BMM package structure; edit the class bodies here,
// but re-run the splitter rather than hand-moving declarations between packages.

import type { T } from "../../_shared.ts";
import { P_C_PRIMITIVE_OBJECT } from "./constraint_model.ts";
import * as openehr_base from "../../../base/mod.ts";

/**
 * Constraint on instances of Boolean. Both attributes cannot be set to False, since this would mean that the Boolean value being constrained cannot be True or False.
 */
export class P_C_BOOLEAN extends P_C_PRIMITIVE_OBJECT {
  override constraint?: undefined = undefined;
  override assumed_value?: openehr_base.Boolean = undefined;
  override default_value?: openehr_base.Boolean = undefined;
}

/**
 * Constraint on instances of STRING.
 */
export class P_C_STRING extends P_C_PRIMITIVE_OBJECT {
  /**
   * String constraint - a list of literal strings and / or regular expression strings delimited by the ‘/’ character.
   */
  override constraint?: undefined = undefined;
  override default_value?: openehr_base.String = undefined;
  override assumed_value?: openehr_base.String = undefined;
}

/**
 * Constraint on instances of Integer.
 */
export class P_C_INTEGER {
}

/**
 * Constraint on instances of Real.
 */
export class P_C_REAL {
}

/**
 * Abstract parent of primitive constrainer classes based on ORDERED base types, i.e. types like Integer, Real, and the Date/Time types. The model constraint is a List of Intervals, which may include point Intervals, and acts as a efficient and formally tractable representation of any number of point values and/or contiguous intervals of an ordered value domain.
 *
 * In its simplest form, the constraint accessor returns just a single point Interval<T> object, representing a single value.
 *
 * The next simplest form is a single proper Interval <T> (i.e. normal two-sided or half-open interval). The most complex form is a list of any combination of point and proper intervals.
 */
export abstract class P_C_ORDERED<T extends openehr_base.Ordered>
  extends P_C_PRIMITIVE_OBJECT {
  override constraint?: undefined = undefined;
}

/**
 * Constrainer type for instances of TERMINOLOGY_CODE. The primary expression of the constraint is in the property \`tuple_constraint', and comes in 3 variations:
 * * a single at-code
 * * a single ac-code, representing a value-set that is defined in the archetype terminology
 * * a list of at- and/or ac-codes, representing the possibilities of a tuple constraint
 * The last possibility above is enabled by the merge_tuple routine, which enables the constraint of another single-valued C_TERMINOLOGY_CODE to be merged with the current one.
 */
export class P_C_TERMINOLOGY_CODE extends P_C_PRIMITIVE_OBJECT {
  override constraint?: openehr_base.String = undefined;
  override assumed_value?: openehr_base.Terminology_code = undefined;
  override default_value?: openehr_base.Terminology_code = undefined;
}

/**
 * Purpose Abstract parent of C_ORDERED types whose base type is an ISO date/time type.
 */
export abstract class P_C_TEMPORAL<T extends openehr_base.Temporal>
  extends P_C_ORDERED<T> {
  /**
   * Internal storage for pattern_constraint
   * @protected
   */
  protected _pattern_constraint?: openehr_base.String;

  /**
   * Optional alternative constraint in the form of a pattern based on ISO8601. See descendants for details.
   */
  get pattern_constraint(): string | undefined {
    return this._pattern_constraint?.value;
  }

  /**
   * Gets the openehr_base.String wrapper object for pattern_constraint.
   * Use this to access openehr_base.String methods.
   */
  get $pattern_constraint(): openehr_base.String | undefined {
    return this._pattern_constraint;
  }

  /**
   * Sets pattern_constraint from either a primitive value or openehr_base.String wrapper.
   */
  set pattern_constraint(val: string | openehr_base.String | undefined) {
    if (val === undefined || val === null) {
      this._pattern_constraint = undefined;
    } else if (typeof val === "string") {
      this._pattern_constraint = openehr_base.String.from(val);
    } else {
      this._pattern_constraint = val;
    }
  }
}

/**
 * ISO 8601-compatible constraint on instances of Time in the form either of a set of validity values, or else date ranges based on the C_ORDERED list constraint. There is no validity flag for ‘hour’, since it must always be by definition mandatory in order to have a sensible time at all. Syntax expressions of instances of this class include “HH:??:xx” (time with optional minutes and seconds not allowed).
 */
export class P_C_TIME {
}

/**
 * ISO 8601-compatible constraint on instances of Date in the form either of a set of validity values, or else date ranges based on the C_ORDERED list constraint. There is no validity flag for ‘year’, since it must always be by definition mandatory in order to have a sensible date at all. Syntax expressions of instances of this class include “YYYY-??-??” (date with optional month and day).
 */
export class P_C_DATE {
}

/**
 * ISO 8601-compatible constraint on instances of Date_Time. There is no validity flag for ‘year’, since it must always be by definition mandatory in order to have a sensible date/time at all. Syntax expressions of instances of this class include “YYYY-MM-DDT??:??:??” (date/time with optional time) and “YYYY-MMDDTHH:MM:xx” (date/time, seconds not allowed).
 */
export class P_C_DATE_TIME {
}

export class P_C_DURATION {
}
